<script>
import FirstView from "@/components/home/FirstView.vue"
import NewWhyClassino from "@/components/home/NewWhyClassino.vue";
import PromotionBanner from "@/components/home/PromotionBanner.vue";
import ClassinoCourses from "@/components/home/ClassinoCourses.vue";
import ClassinoSampleVideoSlider from '@/components/home/ClassinoSampleVideoSlider.vue'
import HowCanClassinoHelpsYou from "@/components/home/HowCanClassinoHelpsYou.vue";
import ClassesForAllGrades from '@/components/home/ClassesForAllGrades.vue'
import OurProfessors from '@/components/home/OurProfessors.vue'
import NewStudentsComments from '@/components/home/NewStudentsComments.vue'
import Contact from '@/components/home/Contact.vue'
import mixinMeta from '@/mixins/mixin.meta'
export default {
  mixins: [mixinMeta],
  components: {
    FirstView,
    PromotionBanner,
    NewWhyClassino,
    ClassinoCourses,
    ClassinoSampleVideoSlider,
    HowCanClassinoHelpsYou,
    OurProfessors,
    ClassesForAllGrades,
    NewStudentsComments,
    Contact
  },
  head() {
    const canonical = '/'
    const title = 'کلاسینو - اولین و بزرگترین آموزشگاه و کلاس آنلاین کنکور و پایه'
    const description = 'کلاسینو آموزشگاه کنکور آنلاینی هست که مجازی سرکلاس حاضر میشی، به صورت زنده با استاد حرف میزنی، تکالیف و آزمون ها جدی پیگیری میشن و از هر جای دنیا میتونی به کلاسینو دسترسی پیدا کنی'
    return this.createMeta({
      title,
      description,
      canonical
    })
  },
}
</script>
<template>
  <div>
    <FirstView></FirstView>
    <PromotionBanner></PromotionBanner>
    <NewWhyClassino></NewWhyClassino>
    <ClassinoCourses></ClassinoCourses>
    <div id="sample-video-sliders">
      <ClassinoSampleVideoSlider></ClassinoSampleVideoSlider>
    </div>
    <HowCanClassinoHelpsYou></HowCanClassinoHelpsYou>
    <ClassesForAllGrades></ClassesForAllGrades>
    <OurProfessors></OurProfessors>
    <NewStudentsComments></NewStudentsComments>
    <Contact></Contact>
  </div>
</template>



<style lang="scss">
.cl__section__subtitle{
  font-size: 24px;
  max-width: 1200px;
  @include media-breakpoint-down(md){
    font-size: 14px;
  }
  color: rgba(52, 64, 84, 1)
}
</style>
